import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=b1b96e86&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=js&"
export * from "./UserSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=b1b96e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b96e86",
  null
  
)

export default component.exports